module.exports = __webpack_public_path__ + "static/media/websiteDesign.a8dde3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/VikasSpools/websiteDesign.jpg
// module id = 371
// module chunks = 0